module.exports = __webpack_public_path__ + "static/media/eraser-medium.6fed04b7.svg";